/**
 * Normalizes axios `response.data` for admin-panel-compliance style handlers
 * (`{ body }`, `{ data }`, or the entity at the root).
 */
export function readComplianceBody<T>(response: { data?: unknown }): T | undefined {
  const root = response?.data;
  if (root == null || typeof root !== "object") return undefined;
  const o = root as Record<string, unknown>;
  if ("body" in o && o.body != null) return o.body as T;
  if ("data" in o && o.data !== undefined) return o.data as T;
  return root as T;
}
